import { Component, input } from '@angular/core';
import { MenuItem } from './../../../_common/model/menu-item';

import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
    selector: 'lay-sub-menu',
    templateUrl: './lay-sub-menu.component.html',
    styleUrls: ['./lay-sub-menu.component.scss'],
    imports: [RouterLinkActive, RouterLink],
})
export class LaySubMenuComponent {
    readonly sumbMenu = input<MenuItem[]>([]);
}
